<template>
  <div
    class="card border-0 accounts-card"
    :class="isDarkMode ? 'accounts-card-dark' : 'accounts-card-light'"
  >
    <div class="accounts-inner">
      <h5 class="accounts-title mb-1">Bankovní účty</h5>
      <p class="accounts-subtitle mb-3">Evidované z příchozích plateb</p>

      <div v-if="loading" class="accounts-empty">Načítám účty…</div>
      <div v-else-if="!accounts.length" class="accounts-empty">
        Zatím tu žádný bankovní účet není. Objeví se po první příchozí platbě.
      </div>

      <div v-else class="d-flex flex-column">
        <div v-for="(item, index) in accounts" :key="item.Account || index" class="account-row">
          <div class="account-number">{{ item.Account }}</div>
          <div v-if="item.AccountName" class="account-meta">{{ item.AccountName }}</div>
          <div v-if="item.AccountBankName" class="account-meta">{{ item.AccountBankName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import dataService from "@/services/dataService";

const store = useStore();
const isDarkMode = computed(() => !!store.state.isDarkMode);
const userID = computed(() => store.getters.getUser?.UserID);
const sessionHash = computed(() => store.getters.isLoggedIn);

const accounts = ref([]);
const loading = ref(false);

const loadAccounts = async () => {
  if (!userID.value || !sessionHash.value) return;
  loading.value = true;
  try {
    const response = await dataService.GetUserAccount(userID.value, sessionHash.value);
    accounts.value = Array.isArray(response?.Data) ? response.Data : [];
  } finally {
    loading.value = false;
  }
};

onMounted(loadAccounts);
</script>

<style scoped>
.accounts-card-light {
  background: #ffffff;
  border: 1px solid #E2E8F0 !important;
  border-radius: 0.85rem !important;
}

.accounts-card-dark {
  background: #0F172A !important;
  border: 1px solid #334155 !important;
  border-radius: 0.85rem !important;
  box-shadow: none !important;
}

.accounts-inner {
  padding: 1.15rem;
}

.accounts-title {
  font-weight: 800;
  color: #0F172A;
}

.accounts-card-dark .accounts-title {
  color: #E2E8F0;
}

.accounts-subtitle {
  font-size: 0.78rem;
  color: #94A3B8;
  margin: 0;
}

.accounts-empty {
  color: #94A3B8;
  font-size: 0.85rem;
}

.account-row {
  padding: 0.75rem 0;
  border-top: 1px solid #E2E8F0;
}

.account-row:last-child {
  padding-bottom: 0;
}

.accounts-card-dark .account-row {
  border-top-color: #334155;
}

.account-number {
  font-weight: 700;
  font-size: 0.88rem;
  color: #0F172A;
  font-variant-numeric: tabular-nums;
}

.accounts-card-dark .account-number {
  color: #E2E8F0;
}

.account-meta {
  font-size: 0.75rem;
  color: #64748B;
  line-height: 1.4;
}

.accounts-card-dark .account-meta {
  color: #94A3B8;
}
</style>
